(function () {
  if (window.BajkaCart && window.BajkaCart.initialized) return;

  var CART_URL = (window.routes && window.routes.cart_url) || (window.theme && window.theme.routes && window.theme.routes.cart_url) || '/cart';
  var reconciliationPending = false;

  function applyStoredPreviews(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-bajka-preview-open]').forEach(function (btn) {
      var item = btn.closest('[data-bajka-group]');
      var group = item && item.getAttribute('data-bajka-group');
      if (!group) return;

      var url = '';
      try {
        url = localStorage.getItem('bajka_preview_' + group) || '';
      } catch (e) {}

      if (url) {
        btn.setAttribute('data-bajka-image', url);
        btn.setAttribute('data-bajka-generated', '1');
      }
    });
  }

  function refreshCart(openAfter) {
    var cartDrawer = document.querySelector('cart-drawer');

    if (cartDrawer) {
      document.dispatchEvent(new CustomEvent('cart:refresh', {
        detail: { open: openAfter === true },
      }));

      if (openAfter === true && typeof cartDrawer.show === 'function') {
        cartDrawer.show();
      }

      window.setTimeout(function () {
        applyStoredPreviews(cartDrawer);
      }, 350);
      return;
    }

    window.location = CART_URL;
  }

  function removeLine(btn) {
    var key = btn.getAttribute('data-line-key');
    if (!key) return;

    btn.style.opacity = '0.4';
    btn.style.pointerEvents = 'none';

    var cartItem = btn.closest('.bajka-cart-item');
    var group = cartItem && cartItem.getAttribute('data-bajka-group');
    var isExtra = cartItem && cartItem.classList.contains('bajka-cart-item--compact');
    var keys = [];

    if (group && !isExtra) {
      document.querySelectorAll('.bajka-cart-item[data-bajka-group="' + group + '"] .bajka-remove-btn').forEach(function (groupBtn) {
        var groupKey = groupBtn.getAttribute('data-line-key');
        if (groupKey) keys.push(groupKey);
      });
    }

    if (!keys.length) keys = [key];

    var updates = {};
    keys.forEach(function (lineKey) {
      updates[lineKey] = 0;
    });

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ updates: updates }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart update failed');
        return response.json();
      })
      .then(function () {
        refreshCart(false);
      })
      .catch(function () {
        window.location = CART_URL;
      });
  }

  function reconcileInvalidLines(root) {
    if (reconciliationPending) return;

    var scope = root || document;
    var invalidLines = scope.querySelectorAll('[data-bajka-reconcile-remove][data-line-key]');
    if (!invalidLines.length) return;

    var updates = {};
    invalidLines.forEach(function (line) {
      var key = line.getAttribute('data-line-key');
      if (!key) return;

      updates[key] = 0;
      line.style.opacity = '0.4';
      line.style.pointerEvents = 'none';
    });

    if (!Object.keys(updates).length) return;

    reconciliationPending = true;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ updates: updates }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart reconciliation failed');
        return response.json();
      })
      .then(function () {
        refreshCart(false);
      })
      .catch(function () {
        window.location = CART_URL;
      })
      .finally(function () {
        reconciliationPending = false;
      });
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      }[character];
    });
  }

  function canTryImage(src) {
    return /^(https?:|data:image\/|blob:|\/)/.test(src || '');
  }

  function resolvePhotoSrc(src) {
    if (!src) return '';
    if (canTryImage(src)) return src;

    var resolver = window.ChildbookPhoto && window.ChildbookPhoto.resolveUrl;
    if (typeof resolver !== 'function') return '';

    try {
      return resolver(src) || '';
    } catch (e) {
      return '';
    }
  }

  function openPreview(openBtn) {
    var previewPopup = document.querySelector('[data-bajka-preview-popup]');
    var previewPages = document.querySelector('[data-bajka-preview-pages]');
    var previewTitle = document.querySelector('[data-bajka-preview-title]');

    if (!previewPopup || !previewPages) return;

    var img = openBtn.getAttribute('data-bajka-image') || '';
    var generated = openBtn.getAttribute('data-bajka-generated') === '1';

    if (previewTitle) {
      previewTitle.textContent = openBtn.getAttribute('data-bajka-title') || 'Podgląd książki';
    }

    var html = '';
    if (img) {
      html += '<div class="bajka-preview-page' + (generated ? ' bajka-preview-page--generated' : '') + '">' +
        '<img src="' + img + '" alt="" loading="lazy">' +
        (generated ? '<span class="bajka-preview-page__tag">Twój podgląd</span>' : '') +
        '</div>';
    }

    previewPages.innerHTML = html;
    previewPages.scrollTop = 0;
    previewPopup.hidden = false;
    document.body.classList.add('bajka-wizard-open');
  }

  function openPhoto(openBtn) {
    var previewPopup = document.querySelector('[data-bajka-preview-popup]');
    var previewPages = document.querySelector('[data-bajka-preview-pages]');
    var previewTitle = document.querySelector('[data-bajka-preview-title]');

    if (!previewPopup || !previewPages) return;

    var rawSrc = openBtn.getAttribute('data-bajka-photo-src') || '';
    var src = resolvePhotoSrc(rawSrc);
    var unavailable = openBtn.getAttribute('data-bajka-photo-unavailable') || 'Photo preview is unavailable';

    if (previewTitle) {
      previewTitle.textContent = openBtn.getAttribute('data-bajka-photo-title') || 'Photo';
    }

    if (src) {
      previewPages.innerHTML = '<div class="bajka-preview-page bajka-preview-page--photo">' +
        '<img alt="" loading="lazy">' +
        '<p class="bajka-preview-page__unavailable">' + escapeHtml(unavailable) + '</p>' +
        '</div>';
      var photoImg = previewPages.querySelector('img');
      if (photoImg) {
        photoImg.addEventListener('error', function () {
          var page = photoImg.closest('.bajka-preview-page');
          if (page) page.classList.add('bajka-preview-page--unavailable');
          photoImg.remove();
        });
        photoImg.setAttribute('src', src);
      }
    } else {
      previewPages.innerHTML = '<div class="bajka-preview-page bajka-preview-page--empty bajka-preview-page--unavailable">' +
        '<p class="bajka-preview-page__unavailable">' + escapeHtml(unavailable) + '</p>' +
        '</div>';
    }

    previewPages.scrollTop = 0;
    previewPopup.hidden = false;
    document.body.classList.add('bajka-wizard-open');
  }

  document.addEventListener('click', function (event) {
    var removeBtn = event.target.closest('.bajka-remove-btn');
    if (removeBtn) {
      event.preventDefault();
      removeLine(removeBtn);
      return;
    }

    var openBtn = event.target.closest('[data-bajka-preview-open]');
    if (openBtn) {
      event.preventDefault();
      openPreview(openBtn);
      return;
    }

    var photoBtn = event.target.closest('[data-bajka-photo-open]');
    if (photoBtn) {
      event.preventDefault();
      openPhoto(photoBtn);
      return;
    }

    var previewPopup = document.querySelector('[data-bajka-preview-popup]');
    if (event.target.closest('[data-bajka-preview-close]') || (previewPopup && event.target === previewPopup)) {
      if (previewPopup) previewPopup.hidden = true;
      document.body.classList.remove('bajka-wizard-open');
    }
  });

  document.addEventListener('cart:updated', function () {
    applyStoredPreviews();
    reconcileInvalidLines();
  });

  document.addEventListener('DOMContentLoaded', function () {
    applyStoredPreviews();
    reconcileInvalidLines();
  });

  window.BajkaCart = {
    initialized: true,
    applyStoredPreviews: applyStoredPreviews,
    reconcileInvalidLines: reconcileInvalidLines,
    refreshCart: refreshCart,
  };
})();
